import { Type } from 'class-transformer';
import { Address } from '@31third/common';
import { TradeInfo } from './trade-info';
import { TransformBigInt } from '../util';
import { Token } from './token';
import { RebalancingHistoryState, TradeSateEnum } from '../enum';
import { Fill } from './fill';
import { Transaction } from './transaction';

export class Trade {
  public id: string;
  @TransformBigInt()
  public fromAmount: bigint;
  @TransformBigInt()
  public toAmount: bigint;
  @TransformBigInt()
  public toValueInNative: bigint | undefined;
  public fromValueInUsd: number;
  public toValueInUsd: number;
  @Type(() => Token)
  public from: Token;
  @Type(() => Token)
  public to: Token;
  @TransformBigInt()
  public minToReceive: bigint;
  public minToReceiveInUsd: number;
  public fromDecimals: number;
  public toDecimals: number;
  public previouslyRequiredTrades: string[];
  public txHandler: Address;
  public txData: string;
  @TransformBigInt()
  public estimatedFees: bigint;
  public estimatedPriceImpact: number;
  public allowanceTarget: string;
  public price: number;
  public guaranteedPrice: number;
  public txHash: string | undefined;
  public tradeState: TradeSateEnum = TradeSateEnum.READY;
  public priceChange = false;
  public rfqt: boolean;
  public expirationTimestamp: Date;
  public fill: Fill;
  public tradeInfos: TradeInfo[];

  // history
  public state: RebalancingHistoryState;
  public transactions: Transaction[] | undefined;

  public update(trade: Trade) {
    if (trade.expirationTimestamp) {
      this.expirationTimestamp = new Date(trade.expirationTimestamp);
    }
    this.price = trade.price;
    this.toValueInNative = trade.toValueInNative;
    this.toValueInUsd = trade.toValueInUsd;
    this.fromValueInUsd = trade.fromValueInUsd;
    this.estimatedPriceImpact = trade.estimatedPriceImpact;
    this.estimatedFees = trade.estimatedFees;
    this.txHandler = trade.txHandler;
    this.txData = trade.txData;
  }

  /**
   * Returns guaranteedPrice.
   * Uses price as backup.
   */
  public getViewPrice(): number {
    return this.guaranteedPrice || this.price;
  }

  /**
   * Returns 1 / guaranteedPrice.
   * Uses 1 / price as backup.
   */
  public getViewInversePrice(): number {
    return 1 / this.guaranteedPrice || 1 / this.price;
  }

  public isWrap(): boolean {
    return this.from.isNative() && this.to.isWrappedNative();
  }

  public isUnwrap(): boolean {
    return this.from.isWrappedNative() && this.to.isNative();
  }

  public toString(): string {
    return `${this.from.symbol} → ${this.to.symbol}.`;
  }
}
